module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Born on the outskirts of Manchester, Northern England, in 1946, Geoff Olton attended St Peter’s College, Oxford, majoring in mathematics. After failing final examinations, he spent one year teaching English to Saudi Arabian Air Force cadets before moving to Kobe, Japan, where he has since lived for 50 years working in teaching, interpretation and translation.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Writing includes a memoir, "), _c('em', [_vm._v("The Way We Are")]), _vm._v(", published by Austin Macauley Publishers Ltd (2022), and also a (as yet unpublished) 5,000-page analysis of the spoken English language in its relationship to Japanese and similarly grouped languages.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0